<div
  class="iframe-container"
  [class.logged-in]="isAuthenticated | async"
  [class.loaded]="showContainerFrame"
  [style.display]="(stateService.visible | async) ? 'inherit' : 'none'"
>
  <iframe #containerFrame [src]="safeFrameSrc" frameborder="0" border="0" marginwidth="0" marginheight="0" scrolling="yes"></iframe>
</div>
